import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { Icon } from '../icons';
import { Button } from '../button';

import { LogoutButtonProps } from './types';

export const LogoutButton = ({
  className,
  buttonClassName,
}: LogoutButtonProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['header']);

  return (
    <Button
      className={className}
      onClick={() => dispatch(logout({ byUser: true }))}
      startIcon={<Icon.LogOut className="[&_path]:fill-current" />}
      buttonClassName={twMerge(
        buttonClassName,
        'bg-white-primary hover:bg-white-hover active:bg-white-active text-black-primary active:text-black-primary'
      )}
    >
      {t('logOut')}
    </Button>
  );
};
